import axiosGraphQL from './GraphQL/axiosGraphQL';
import axiosPowerBi from './setup/axiosPowerBi';

const PowerBiApis = {
  getAccessToken: async (params: any) => {
    return await axiosGraphQL.get(
      `/powerbi/reports/${params.groupId}/${params.reportId}`,
    );
  },
};

export default PowerBiApis;
